<template>
    <div>
        Otomasyon görevi kredisi bitti.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "AutomationTaskCreditDone",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
